import React from 'react'
import PropTypes from 'prop-types'
import { isString } from 'lodash-es'

import './BigLoaderComponent.scss'

const BigLoaderComponent = ({ loadingText, className }) => {
  return (
    <div className={`big-loader-component ${className || ''}`}>
      <div className="loader">{loadingText}</div>
      {isString(loadingText) ? (
        <div className="text">{loadingText}</div>
      ) : (
        loadingText
      )}
    </div>
  )
}

BigLoaderComponent.propTypes = {
  loadingText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
}

export default BigLoaderComponent
